import React, { useState } from 'react';
import { ClickAwayListener, Tooltip } from '@material-ui/core';
import styles from './style.module.scss';
import { FitSummarySlider, ProductReviews } from '..';
import { SiteSettings } from 'src/scripts/utils/environment';

const ReviewsSummaryTooltip = ({ reviewsData }: { reviewsData?: ProductReviews }) => {
  const [open, setOpen] = useState(false);

  if (!reviewsData) return null;

  const tooltipClose = () => {
    setOpen(false);
  };

  let summary: string | undefined;
  let fitRating: number | undefined;
  let fitRange: number | undefined;
  let fitLabels: string[] | undefined;

  const isBazaarvoiceReviewHighlightsEnabled = SiteSettings?.bazaarvoiceReviewHighlightsEnabled;
  const aloReviewHighlights = window.server_pdp_data?.metaFields.aloReviews['review-highlights'];
  summary = isBazaarvoiceReviewHighlightsEnabled ? reviewsData.summary || aloReviewHighlights : aloReviewHighlights;
  fitRating = reviewsData.fit.rating;
  fitRange = reviewsData.fit.range;
  fitLabels = reviewsData.fit.labels;
  if (fitRating < 0 || fitRange < 0 || fitLabels?.length === 0) return null;

  if (!(fitRating != null || summary)) return null;

  return (
    <ClickAwayListener onClickAway={tooltipClose}>
      <Tooltip
        onClose={tooltipClose}
        open={open}
        arrow
        disableFocusListener
        disableHoverListener
        disableTouchListener
        classes={{
          popper: styles.reviewsSummaryTooltip,
          tooltip: styles.tooltip,
          arrow: styles.arrow,
        }}
        title={
          <div className="reviews-summary">
            <div className="summary-wrapper row">
              {fitRating != null && fitRange != null && fitLabels ? (
                <FitSummarySlider
                  fullWidth={true}
                  fitAverageRating={fitRating}
                  fitRatingRange={fitRange}
                  fitLabels={fitLabels}
                />
              ) : null}
              {summary && (
                <div className="reviews-highlight col-12">
                  <div className="summary-subtitle">Review Highlights</div>
                  <p className="summary-text">{summary}</p>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-12 anchor-wrapper">
                <a href="#alo-reviews-widget" className="btn-anchor">
                  VIEW ALL REVIEWS
                </a>
              </div>
            </div>
          </div>
        }
        placement={'bottom'}
      >
        <span className={styles.reviewsSummaryLabel} onClick={() => setOpen(!open)}>
          Review Summary
        </span>
      </Tooltip>
    </ClickAwayListener>
  );
};

export default ReviewsSummaryTooltip;
